import React, { useState, useEffect, useRef, useCallback } from 'react';
import { showToast } from '../Common/Messages';

const OTPVerificationPanel = (props) => {

    const validMinute = 30;
    const style = props.classStyle ?? '';
    const [userId, setUserId] = useState(props.state.userId);
    const [userName, setUserName] = useState(props.state.userName);
    const [isRun, setIsRun] = useState(false);
    const [isVerification, setIsVerification] = useState(false);
    const [showAuth, setShowAuth] = useState(props.authAlreadySent ?? false);
    const [emailVerificationSend, setEmailVerificationSend] = useState(props.authAlreadySent ?? false);
    const [authCode, setAuthCode] = useState("");
    const [validTime, setValidTime] = useState(validMinute * 60);
    const otpType = props.otpType ?? "1";
    const autoRequestAttempted = useRef(false);

    useEffect(() => {
        setUserId(props.state.userEmail !== undefined && props.state.userEmail !== "" ? props.state.userEmail : props.state.userId);
        setUserName(props.state.userName);
        let interval;
        if (validTime > 0 && showAuth) {
            interval = setInterval(() => {
                setValidTime((prevTime) => prevTime - 1);
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [validTime, showAuth, props.state.userId, props.state.userName, props.state.userEmail]);

    const handleRequestAuth = useCallback((event) => {
        event?.preventDefault();
        if (!isRun) {
            if (userId === '' || userName === '') {
                showToast('warning', '입력하지 않은 정보가 있습니다.');
                return;
            }
            let emailExpression = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
            if (!emailExpression.test(userId)) {
                showToast('warning', '이메일 주소가 올바르지 않습니다.');
                return;
            }
            setIsRun(true);
            setValidTime(validMinute * 60);
            const userInfo = {
                userId: encodeURI(userId),
                userName: encodeURI(userName),
                authType: encodeURI(props.authType ?? ""),
                userPhoneNum: encodeURI(props.state.userPhoneNum ?? ""),
                otpType: encodeURI(otpType ?? "1")
            };
            fetch('api/Login/OTPVerificationSend', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify(userInfo)
            }).then((response) => response.json())
                .then((data) => {
                    setIsRun(false);
                    if (data.status === 'OK') {
                        showToast('success', data.message);
                        if (props.fnAfterRequestAuth !== undefined) {
                            props.fnAfterRequestAuth();
                        }
                        setShowAuth(true);
                        setEmailVerificationSend(true);
                    } else {
                        showToast('warning', data.message);
                    }
                });
        }
    }, [isRun, otpType, props.authType, props.fnAfterRequestAuth, props.state.userPhoneNum, userId, userName]);

    useEffect(() => {
        if (!props.autoRequestAuth || autoRequestAttempted.current || emailVerificationSend) {
            return;
        }
        if (userId === '' || userName === '') {
            return;
        }

        autoRequestAttempted.current = true;
        handleRequestAuth();
    }, [props.autoRequestAuth, emailVerificationSend, handleRequestAuth, userId, userName]);

    const handleAuthCodeChange = (event) => {
        let number = /^[0-9]+$/;
        let value = event.target.value;
        if (number.test(value) === true || value === '') {
            setAuthCode(value);
        }
    };

    const handleCheckAuth = (event) => {
        event.preventDefault();
        if (!isRun) {
            setIsRun(true);
            if (validTime === 0) {
                showToast('warning', '유효시간이 만료되었습니다.');
                setIsRun(false);
                return;
            }
            const userInfo = {
                userEmail: encodeURI(userId),
                authCode: (authCode === "" ? "0" : authCode),
                validTime: validMinute
            };
            fetch('api/Login/OTPVerificationCheck', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify(userInfo)
            }).then((response) => response.json())
                .then((data) => {
                    setIsRun(false);
                    if (data.status === 'OK') {
                        showToast('success', data.message);
                        if (props.fnAfterCheckAuth !== undefined) {
                            props.fnAfterCheckAuth(authCode);
                        }
                        setShowAuth(false);
                        setIsVerification(true);
                    } else {
                        showToast('warning', data.message);
                    }
                });
        }
    };

    const authButtonClass = () => {
        if (props.authAlreadySent) {
            return null;
        }
        if (props.autoRequestAuth && !isVerification) {
            return null;
        }
        if (isVerification) {
            return (
                <button className='btn-auth btn-dis'> 인증 완료</button>
            );
        } else if (!emailVerificationSend) {
            return (
                <button onClick={handleRequestAuth} className='btn-auth'>{props.buttonTitle}</button>
            );
        } else {
            return null;
        }
    }

    return (
        <div className={"email-auth-wrap " + style}>
            {authButtonClass()}
            {showAuth && (
                <div className="email-auth-box">
                    <p className="txt-title">{otpType === "2" ? "카카오톡으로" : "이메일로"} 전송된 인증번호를 입력해 주세요.</p>
                    <div className="auth-input">
                        <input
                            maxLength="6"
                            value={authCode}
                            onChange={handleAuthCodeChange}
                            placeholder='인증번호를 입력하세요.'
                            autoFocus
                        />
                        <div className="timer">
                            {Math.floor(validTime / 60)}:
                            {validTime % 60 < 10 ? `0${validTime % 60}` : validTime % 60}
                        </div>
                        <button onClick={handleCheckAuth} className='btn-primary'>확인</button>
                    </div>
                    {!props.authAlreadySent && (
                        <div className="resend">
                            <span className="txt">인증번호를 받지 못하셨나요? </span>
                            <a onClick={handleRequestAuth} className="btn-resend">인증번호 재전송</a>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default OTPVerificationPanel;
